export default __webpack_public_path__ + "static/media/Website images-07.bc959f4c.jpg";